import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { ContactMasterData } from "types/models/contactMaster/ContactMasterApp";

const uniformWidth = "150px";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: 150,
  width: uniformWidth,
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: ContactMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  return (
    <TableRow key={data.id} className="item-hover">
      <StyledTableCell align="left" title={data.createdAt}>
        {data.createdAt}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.source}>
        {data.source}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.reference}>
        {data.reference}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.name}>
        {data.name}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.contactNo}>
        {data.contactNo}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.email}>
        {data.email}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.city}>
        {data.city}
      </StyledTableCell>
      <StyledTableCell align="left" title={data.message}>
        {data.message}
      </StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
